import { render, staticRenderFns } from "./tableCustomPagination.vue?vue&type=template&id=0956e003"
import script from "./tableCustomPagination.vue?vue&type=script&lang=js"
export * from "./tableCustomPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports